"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageStore = void 0;
var page_1 = require("./page");
Object.defineProperty(exports, "pageStore", { enumerable: true, get: function () { return page_1.pageStore; } });
//# sourceMappingURL=index.js.map